import { render, staticRenderFns } from "./SortableGrid.vue?vue&type=template&id=77329f95&lang=html"
import script from "./SortableGrid.vue?vue&type=script&lang=js"
export * from "./SortableGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports